import React from 'react';

import CommunityAdminContent from './CommunityAdminContent';
import { CommunityCreateProvider } from './CommunityAdminContextProvider';

interface Props {
  open: boolean;
  communityId?: number;
  onClose: (refresh?: boolean) => void;
}

const CommunityAdminModal = ({ open, communityId, onClose }: Props) => {
  return (
    <CommunityCreateProvider communityId={communityId} open={open} onClose={onClose}>
      <CommunityAdminContent />
    </CommunityCreateProvider>
  );
};

export default CommunityAdminModal;
